import React from "react";

export const ErrorIcon: React.FC = () => {
  return (
    <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Zm0 .96a10.96 10.96 0 1 0 0-21.92 10.96 10.96 0 0 0 0 21.92Z"
        fill="#BF1902"
      />
      <path
        d="M11.59 14.07h.92l.42-4.2V6.69h-1.76v3.2l.42 4.19Zm-.52 3.21h1.96v-1.95h-1.96v1.95Z"
        fill="#BF1902"
      />
    </svg>
  );
};

export const CheckmarkIcon: React.FC = () => {
  return (
    <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 4.585 5.907 12 2 8.42l.64-.585 3.267 2.993L13.36 4l.64.585Z"
        fill="currentColor"
      ></path>
    </svg>
  );
};

export const XCrossIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      fillOpacity=".8"
      fillRule="evenodd"
      d="m8.335 8.333 2.933 2.933.565-.565L8.9 7.768l3.034-3.034-.565-.566-3.034 3.034-3.101-3.1-.566.565 3.101 3.1-3 3 .566.566 3-3Z"
      clipRule="evenodd"
    />
  </svg>
);

/**
 * Dashed ring — marks an unfulfilled-but-actionable requirement row. Outstanding work is
 * neutral rather than failed: a solid cross read as "you got this wrong" on requirements the
 * member had no chance to do yet (FEWEB-2666).
 */
export const DashedCircleIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="3 5"
    />
  </svg>
);

/** Plain padlock — marks a requirement row as locked (not yet actionable). */
export const LockIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 2.5a2.25 2.25 0 0 0-2.25 2.25V6.5h4.5V4.75A2.25 2.25 0 0 0 8 2.5ZM11 6.5V4.75a3 3 0 0 0-6 0V6.5a1.5 1.5 0 0 0-1.5 1.5v4A1.5 1.5 0 0 0 5 13.5h6a1.5 1.5 0 0 0 1.5-1.5v-4A1.5 1.5 0 0 0 11 6.5Zm-6.75 1.5c0-.414.336-.75.75-.75h6c.414 0 .75.336.75.75v4a.75.75 0 0 1-.75.75H5a.75.75 0 0 1-.75-.75v-4Z"
      clipRule="evenodd"
    />
  </svg>
);
